var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMagic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Show-Hat-Magician-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Show Hat Magician 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.11 17.65a23.06 23.06 0 0 1 -6.36 0.85 23.06 23.06 0 0 1 -6.36 -0.85 0.53 0.53 0 0 0 -0.44 0.08 0.48 0.48 0 0 0 -0.2 0.4v3.63a1 1 0 0 0 0.43 0.82C5.79 23 7.67 24 11.75 24s5.95 -1 6.57 -1.42a1 1 0 0 0 0.43 -0.82v-3.63a0.48 0.48 0 0 0 -0.2 -0.4 0.53 0.53 0 0 0 -0.44 -0.08Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.78a0.25 0.25 0 0 1 0.25 -0.25h0.25a0.5 0.5 0 0 0 0.5 -0.5 0.5 0.5 0 0 0 -0.5 -0.5H2.5a0.25 0.25 0 0 1 -0.25 -0.25V1a0.5 0.5 0 0 0 -1 0v0.25a0.25 0.25 0 0 1 -0.25 0.28H0.75a0.5 0.5 0 0 0 -0.5 0.5 0.5 0.5 0 0 0 0.5 0.5H1a0.25 0.25 0 0 1 0.25 0.25V3a0.5 0.5 0 0 0 1 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 6.52a0.5 0.5 0 0 0 -0.5 -0.5H21a0.25 0.25 0 0 1 -0.25 -0.25v-0.25a0.5 0.5 0 0 0 -1 0v0.25a0.25 0.25 0 0 1 -0.25 0.23h-0.25a0.5 0.5 0 0 0 -0.5 0.5 0.5 0.5 0 0 0 0.5 0.5h0.25a0.25 0.25 0 0 1 0.25 0.25v0.25a0.5 0.5 0 0 0 1 0v-0.23A0.25 0.25 0 0 1 21 7h0.25a0.5 0.5 0 0 0 0.5 -0.48Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.67 0.6a1 1 0 0 0 -1.32 -0.52l-9.79 4A1 1 0 0 0 13 6a1 1 0 0 0 0.4 -0.08l9.79 -4A1 1 0 0 0 23.67 0.6Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.63 5.87a0.93 0.93 0 0 0 -0.52 0.84 1 1 0 0 0 0.52 0.85l1.49 0.74a2.52 2.52 0 0 1 1.13 1.13L5 10.91a0.94 0.94 0 0 0 1.69 0l0.74 -1.48A2.52 2.52 0 0 1 8.55 8.3L10 7.56a1 1 0 0 0 0.52 -0.85 0.93 0.93 0 0 0 -0.52 -0.84l-1.45 -0.75A2.55 2.55 0 0 1 7.42 4l-0.74 -1.49a1 1 0 0 0 -1.68 0L4.25 4a2.55 2.55 0 0 1 -1.13 1.12Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 9c-0.53 0 -1 0 -1.54 0.05a0.19 0.19 0 0 0 -0.1 0l-1 0.49a1.7 1.7 0 0 0 -0.75 0.75l-0.76 1.6a0.06 0.06 0 0 0 0 0.06s0 0 0.06 0a16.24 16.24 0 0 1 4.09 -0.47c3.72 0 6 1 6 1.5s-2.28 1.5 -6 1.5C5.45 14.5 4 11.92 3.56 11a0.24 0.24 0 0 0 -0.15 -0.13 0.25 0.25 0 0 0 -0.21 0A2.65 2.65 0 0 0 1.75 13c0 2.21 4.48 4 10 4s10 -1.79 10 -4 -4.48 -4 -10 -4Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMagic);
export default ForwardRef;